import { createContext } from 'react';

export interface PageErrorContext {
  hasError: boolean;
  errorMessage?: string;
  errors: Record<string, boolean>;
  setError: (key: string, hasError: boolean, errorMessage?: string) => void;
  clearError: (key: string) => void;
}

export const pageErrorContext = createContext<PageErrorContext>({
  hasError: false,
  errorMessage: undefined,
  errors: {},
  setError: () => {},
  clearError: () => {},
});
